<div class="content">
  @if (posting) {
    <div itemscope itemtype="https://schema.org/JobPosting">
      <div class="component-header">
        <h3 class="pcl-tagline highlight-line">Job Postings</h3>
        <h1 itemprop="title">{{ posting.jobTitle }}</h1>
      </div>
      <div>
        <ul class="summary-flex-container" [ngClass]="{ isHandset: breakpointService.isMobile }">
          <li>
            <div>
              <p class="pcl-control-label no-margin no-padding pcl-dark-grey">Job Title</p>
              <p class="pcl-control-label no-margin no-padding bold" itemprop="title">{{ posting.jobTitle }}</p>
            </div>
          </li>
          <li>
            <div>
              <p class="pcl-control-label no-margin no-padding pcl-dark-grey">Location</p>
              <p
                class="pcl-control-label no-margin no-padding bold"
                itemprop="jobLocation"
                itemscope
                itemtype="https://schema.org/Place">
                <span itemprop="address" itemscope itemtype="https://schema.org/PostalAddress">
                  @if (posting.city) {
                    <span itemprop="addressLocality">{{ posting.city }}</span
                    >,
                  }
                  @if (posting.isoSubdivisionCode) {
                    <span itemprop="addressRegion">{{ provinceName }}</span
                    >,
                  }
                  @if (posting.isoCountryCode) {
                    <span itemprop="addressCountry">{{ countryName }}</span>
                  }
                </span>
              </p>
            </div>
          </li>
          <li>
            <div>
              <p class="pcl-control-label no-margin no-padding pcl-dark-grey">Job Number</p>
              <p class="pcl-control-label no-margin no-padding bold">{{ posting.jobPostingNumber }}</p>
            </div>
          </li>
          <li>
            <div>
              <p class="pcl-control-label no-margin no-padding pcl-dark-grey">Company</p>
              <p
                class="pcl-control-label no-margin no-padding bold"
                itemprop="hiringOrganization"
                itemscope
                itemtype="https://schema.org/Organization">
                <span itemprop="name">{{ posting.companyName }}</span>
              </p>
            </div>
          </li>
          <li>
            <div>
              <p class="pcl-control-label no-margin no-padding pcl-dark-grey">Posting Date</p>
              <p class="pcl-control-label no-margin no-padding bold">
                <meta itemprop="datePosted" [attr.content]="posting.postingDate | date: 'yyyy-MM-dd' : 'UTC'" />
                {{ posting.postingDate | date: 'longDate' : 'UTC' }}
              </p>
            </div>
          </li>
          <li>
            <div>
              <p class="pcl-control-label no-margin no-padding pcl-dark-grey">Closing Date</p>
              <p class="pcl-control-label no-margin no-padding bold">
                @if (posting.expiryDate) {
                  <meta itemprop="validThrough" [attr.content]="posting.expiryDate | date: 'yyyy-MM-dd' : 'UTC'" />
                }
                {{ (posting.expiryDate | date: 'longDate' : 'UTC') || 'Ongoing' }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="action-container alt">
        <ul class="action-flex-container">
          <li class="action-flex-item">
            @if (!activeApplication) {
              <button
                mat-flat-button
                class="mat-flat-button primary"
                color="primary"
                (click)="apply(posting)"
                data-gtm-id="apply-now">
                Apply Now
              </button>
            }
            @if (activeApplication) {
              <button mat-flat-button class="mat-flat-button disabled" disabled>
                Applied on {{ activeApplication.availableOn | date: 'mediumDate' }}
              </button>
            }
          </li>
          <li class="action-flex-item">
            <button
              mat-flat-button
              class="mat-flat-button secondary"
              (click)="openDialog(posting)"
              data-gtm-id="share-job">
              Share Job
            </button>
          </li>
          <li class="action-flex-item">
            <button mat-flat-button class="mat-flat-button secondary" routerLink="/jobs">View Job Postings</button>
          </li>
        </ul>
      </div>
      <div [innerHTML]="posting.htmlContent" class="job-posting-container" itemprop="description"></div>
      <div class="action-container">
        <ul class="action-flex-container justify-left">
          <li class="action-flex-item">
            @if (!activeApplication) {
              <button
                mat-flat-button
                class="mat-flat-button primary"
                color="primary"
                (click)="apply(posting)"
                data-gtm-id="apply-now">
                Apply Now
              </button>
            }
            @if (activeApplication) {
              <button mat-flat-button class="mat-flat-button disabled" disabled>
                Applied on {{ activeApplication.availableOn | date: 'mediumDate' }}
              </button>
            }
          </li>
          <li class="action-flex-item">
            <button
              mat-flat-button
              class="mat-flat-button secondary"
              (click)="openDialog(posting)"
              data-gtm-id="share-job">
              Share Job
            </button>
          </li>
          <li class="action-flex-item">
            <button mat-flat-button class="mat-flat-button secondary" routerLink="/jobs">View Job Postings</button>
          </li>
        </ul>
      </div>
    </div>
  }
</div>
